/**
 * Home / account settings page strings.
 *
 * Namespace: home
 */
export const home = {
  // Header
  header: {
    ariaLabel: "Felhasználói fejléc",
  },

  // Page
  page: {
    title: "Fiókbeállítások",
    subtitle: "Kezelje a fiókjához tartozó adatokat",
    backToApplication: "Vissza az alkalmazáshoz",
  },

  // Profile section
  profile: {
    sectionTitle: "Fiók adatai",
    email: "E-mail cím",
    name: "Név",
    unknownName: "Ismeretlen felhasználó",
  },

  // Change password section
  changePassword: {
    sectionTitle: "Jelszó módosítása",
    currentPasswordLabel: "Jelenlegi jelszó",
    currentPasswordPlaceholder: "••••••••",
    newPasswordLabel: "Új jelszó",
    newPasswordPlaceholder: "••••••••",
    newPasswordHelperText: "Legalább 8 karakter",
    confirmPasswordLabel: "Új jelszó megerősítése",
    confirmPasswordPlaceholder: "••••••••",
    submitButton: "Jelszó mentése",

    success: {
      title: "Jelszó megváltoztatva",
      message: "Az új jelszava sikeresen mentve.",
    },

    errors: {
      invalidCurrentPassword: "A megadott jelenlegi jelszó helytelen.",
      sameAsCurrentPassword: "Az új jelszó nem egyezhet meg a jelenlegivel.",
      changeFailed: "A jelszó módosítása sikertelen. Kérjük, próbálja újra.",
    },
  },

  // Logout section
  logout: {
    sectionTitle: "Kijelentkezés",
    description: "Bezárja az aktuális munkamenetet.",
    logoutButton: "Kijelentkezés",
    confirmQuestion: "Biztosan ki szeretne lépni?",
    confirmDescription: "Az aktuális munkamenete megszűnik.",
    confirmYes: "Igen, kilépek",
    confirmNo: "Mégse",
  },
} as const;
